import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, InMemoryCache, split, from } from '@apollo/client/core';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { environment } from "../environments/environment";
import { inject } from '@angular/core';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';

const httpUri = `${environment.graphqlHttpUri}`;
const wsUri = `${environment.graphqlWssUri}`;

export const graphqlProvider = provideApollo(() => {
    const wsLink = new GraphQLWsLink(createClient({
        url: wsUri,
    }));

    const errorLink = onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            console.error('GraphQL Error:', graphQLErrors);
        }
        if (networkError) {
            console.error('Network Error:', networkError);
        }
    });

    const httpLink = inject(HttpLink).create({
        uri: httpUri,
    });

    const httpLinkWithError = from([
        errorLink,
        httpLink
    ]);

    const splitLink = split(
        ({ query }) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === 'OperationDefinition' &&
                definition.operation === 'subscription'
            );
        },
        wsLink,
        httpLinkWithError
    );

    return {
        link: splitLink,
        cache: new InMemoryCache(),
    } as ApolloClientOptions<any>;
});
